// extracted by mini-css-extract-plugin
export default {"circleWrapper":"circleWrapper_circleWrapper__X3SId","rotate":"circleWrapper_rotate__YCq21"};